import { getListSlugsByScreen } from '@/services/apis/modules/indicators';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

interface IState {
  loading: boolean;
  tags: undefined | ISlugs;
  error: string;
}
export interface ISlugs {
  slug: string;
  title: string;
}
const initialState: IState = {
  loading: false,
  tags: undefined,
  error: '',
};

export const fetchListSlugs = createAsyncThunk(
  '/slugs',
  async (screen: string) => {
    const res = await getListSlugsByScreen(screen);
    return res;
  },
);

const slugsSlice = createSlice({
  name: 'slugs',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchListSlugs.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchListSlugs.fulfilled, (state, action) => {
      state.loading = false;
      state.tags = action.payload;
      state.error = '';
    });
    builder.addCase(fetchListSlugs.rejected, (state) => {
      state.loading = true;
      state.tags = undefined;
    });
  },
});

export default slugsSlice.reducer;
